<template>
  <div class="footer">
    <div class="one" :class="category == 1 ? 'on' : ''" @click="util.topage('home')">
      <img v-if="category == 1" src="@/assets/images/icon/home_icon_251286-1.png" />
      <img v-else src="@/assets/images/icon/home_icon_251286.png" />
      <div>Home</div>
    </div>
    <div class="one" :class="category == 2 ? 'on' : ''" @click="util.topage('order')">
      <img v-if="category == 2" src="@/assets/images/icon/data_icon_219962-1.png" />
      <img v-else src="@/assets/images/icon/data_icon_219962.png" />
      <div>Order</div>
    </div>
    <div class="one" :class="category == 3 ? 'on' : ''" @click="util.topage('market', 'BTC')">
      <img v-if="category == 3" src="@/assets/images/icon/tuner_settings_equalizer_icon_250959-1.png" />
      <img v-else src="@/assets/images/icon/tuner_settings_equalizer_icon_250959.png" />
      <div>Market</div>
    </div>
    <div class="one" :class="category == 4 ? 'on' : ''" @click="util.topage('asset')">
      <img v-if="category == 4" src="@/assets/images/icon/layers_icon_251258-1.png" />
      <img v-else src="@/assets/images/icon/layers_icon_251258.png" />
      <div>Asset</div>
    </div>
    <!-- <div class="one" :class="category==6?'on':''" @click="util.topage('chat')">
          <img v-if="category==6" src="@/assets/images/icon/chat_icon-1.png"/>
          <img v-else src="@/assets/images/icon/chat_icon.png"/>
          <div>Chat</div>
        </div> -->
    <div class="one" :class="category == 5 ? 'on' : ''" @click="util.topage('mine')">
      <img v-if="category == 5" src="@/assets/images/icon/user_icon_251290-1.png" />
      <img v-else src="@/assets/images/icon/user_icon_251290.png" />
      <div>Profile</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
export default {
  data() {
    return {
      category: 1,
    };
  },
  created() {
    switch (this.$route.name) {
      case "home": {
        this.category = 1;
        break;
      }
      case "order": {
        this.category = 2;
        break;
      }
      case "market": {
        this.category = 3;
        break;
      }
      case "asset": {
        this.category = 4;
        break;
      }
      case "mine": {
        this.category = 5;
        break;
      }
      case "chat": {
        this.category = 6;
        break;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.footer {

  position: fixed;
  width: 100%;
  height: 1.3rem;
  background: rgb(250, 249, 249);
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 0.01rem solid rgb(197, 191, 191);

  .one {
    cursor: pointer;
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    img {
      width: 0.6rem;
      height: auto;
    }

    div {
      width: 100%;
      text-align: center;
      font-size: 0.28rem;
      font-weight: bold;
    }
  }

  .on {
    color: #628808;
  }
}
</style>